/**
 * Destination Modal Component JavaScript
 * 
 * Handles the functionality for destination detail modals used across
 * all destination pages.
 */

/**
 * Show destination details in modal
 * @param {string} name - Destination name
 * @param {string} location - Location (state, country, etc)
 * @param {string} description - Description text
 * @param {string} searchQuery - Google Maps search query
 */
function showDestinationDetails(name, location, description, searchQuery) {
    const titleElement = document.getElementById('destinationModalLabel');
    const descriptionElement = document.getElementById('destinationDescription');
    const mapElement = document.getElementById('destinationMap');
    
    if (titleElement) {
        titleElement.textContent = name + (location ? ', ' + location : '');
    }
    
    if (descriptionElement) {
        descriptionElement.textContent = description;
    }
    
    if (mapElement) {
        // Update Google Maps iframe with the destination location
        const mapUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dRWTgaQzuU17R8&q=${encodeURIComponent(searchQuery)}`;
        mapElement.src = mapUrl;
    }
}

// Make function globally available
window.showDestinationDetails = showDestinationDetails;
